export var PriceTransparencyRating;
(function (PriceTransparencyRating) {
    PriceTransparencyRating["NO_DATA"] = "NO_DATA";
    PriceTransparencyRating["GREAT"] = "GREAT";
    PriceTransparencyRating["GOOD"] = "GOOD";
    PriceTransparencyRating["FAIR"] = "FAIR";
    PriceTransparencyRating["POOR"] = "POOR";
    PriceTransparencyRating["OFF_RANGE"] = "OFF_RANGE";
    PriceTransparencyRating["OFF_RANGE_LOW"] = "OFF_RANGE_LOW";
    PriceTransparencyRating["OFF_RANGE_HIGH"] = "OFF_RANGE_HIGH";
})(PriceTransparencyRating || (PriceTransparencyRating = {}));
export const RatingMap = {
    NO_DATA: 'no-data',
    GREAT: 'great',
    GOOD: 'good',
    FAIR: 'fair',
    POOR: 'poor',
    OFF_RANGE: 'off-range',
    OFF_RANGE_LOW: 'off-range',
    OFF_RANGE_HIGH: 'off-range'
};
//# sourceMappingURL=PriceTransparencyRating.js.map